import React from 'react'
import { motion } from 'framer-motion'
const ReturnLoading = () => {
  
  return (
     <div className="h-screen w-full flex flex-col items-center justify-center bg-gradient-to-br from-[#e0f0ff] via-white to-[#f0eaff] overflow-hidden relative">
        {/* Animated glow background */}
        {/* <div className="absolute inset-0">
    <div className="absolute -top-32 -left-32 w-96 h-96 bg-[#007aff]/20 blur-3xl rounded-full animate-pulse" />
    <div className="absolute bottom-0 right-0 w-[28rem] h-[28rem] bg-[#a855f7]/20 blur-3xl rounded-full animate-pulse" />
  </div> */}
        <motion.div
          className="absolute w-64 h-64 sm:w-72 sm:h-72 md:w-80 md:h-80 bg-gradient-to-r from-indigo-400 via-blue-400 to-purple-400 blur-3xl opacity-30 rounded-full"
          animate={{ scale: [1, 1.1, 1] }}
          transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
        />

        {/* Bloom loader (SVG) */}
        <div className="relative flex flex-col items-center space-y-6 z-10 animate-fadeIn">
          <div className="relative w-24 h-24 flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="80"
              height="80"
              className="drop-shadow-[0_0_15px_rgba(0,122,255,0.4)]"
            >
              {/* Icon from SVG Spinners by Utkarsh Verma */}
              <circle cx="12" cy="12" r="0" fill="#007aff">
                <animate
                  id="SVG0cdVlcnN"
                  fill="freeze"
                  attributeName="r"
                  begin="0;SVGftllRbIv.begin+0.6s"
                  calcMode="spline"
                  dur="1.2s"
                  keySplines=".52,.6,.25,.99"
                  values="0;11"
                />
                <animate
                  fill="freeze"
                  attributeName="opacity"
                  begin="0;SVGftllRbIv.begin+0.6s"
                  calcMode="spline"
                  dur="1.2s"
                  keySplines=".52,.6,.25,.99"
                  values="1;0"
                />
              </circle>
              <circle cx="12" cy="12" r="0" fill="#007aff">
                <animate
                  id="SVGftllRbIv"
                  fill="freeze"
                  attributeName="r"
                  begin="SVG0cdVlcnN.begin+0.6s"
                  calcMode="spline"
                  dur="1.2s"
                  keySplines=".52,.6,.25,.99"
                  values="0;11"
                />
                <animate
                  fill="freeze"
                  attributeName="opacity"
                  begin="SVG0cdVlcnN.begin+0.6s"
                  calcMode="spline"
                  dur="1.2s"
                  keySplines=".52,.6,.25,.99"
                  values="1;0"
                />
              </circle>
            </svg>
          </div>

          
        </div>
      </div>
  )
}

export default ReturnLoading
